const userQueryKeys = {
  all: ['user'] as const,
  me: () => [...userQueryKeys.all, 'me'] as const,
  currentPointsLists: () => [...userQueryKeys.all, 'currentPoints'] as const,
  currentPointsList: (search?: string) => [...userQueryKeys.all, 'currentPoints', { search }] as const,
}

export default userQueryKeys
